import {
    Button,
    Dialog,
    DialogTitle,
    Stack,
    IconButton,
    Typography,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";
import React, { useCallback } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "../../services/axios";
import defaultAxios, { AxiosError } from "axios";
import Swal from "sweetalert2";
import { useHapusWarehouseModal } from "../../context/hapusWarehouseModalContext";

interface IModalDeleteWarehouseProps {
    refetch: () => void;
}

const ModalDeleteWarehouse = ({ refetch }: IModalDeleteWarehouseProps) => {
    const {
        isOpenModalHapusWarehouse,
        closeModalHapusWarehouse,
        namaWarehouse,
        idWarehouse,
    } = useHapusWarehouseModal();

    const handleDelete = async (id: string | number | undefined) => {
        try {
            await axios.delete(`/api/warehouse/${id}`);
            refetch();
            closeModalHapusWarehouse();
        } catch (error) {
            // console.error(error);
            handleErrorResponse(error);
        }
    };

    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.message}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalHapusWarehouse();
                } else {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalHapusWarehouse();
                }
            }
        },
        [closeModalHapusWarehouse],
    );

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            open={isOpenModalHapusWarehouse}
            onClose={closeModalHapusWarehouse}
            PaperProps={{
                sx: { borderRadius: 1 },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton onClick={closeModalHapusWarehouse}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Hapus Warehouse
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Warehouse {namaWarehouse} akan dihapus secara permanen.
                    Yakin ingin menghapus?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <Button
                    variant="outlined"
                    onClick={() => handleDelete(idWarehouse)}
                    color="error"
                >
                    Hapus
                </Button>
                <Button
                    variant="contained"
                    onClick={closeModalHapusWarehouse}
                    color="error"
                >
                    Tidak
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteWarehouse;
